import * as tslib_1 from "tslib";
import selectFirstRow from './selectFirstRow';
import selectRowInDirection from './selectRowInDirection';
import { SelectionDirection } from 'owa-mail-list-store';
/**
 * Select the next row in multiselect mode
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export default function multiselectNextRowInternal(tableView, mailListItemSelectionSource) {
    var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
    if (selectedRowKeys.length > 0) {
        var selectedRowKey = selectedRowKeys[selectedRowKeys.length - 1];
        selectRowInDirection(tableView, SelectionDirection.Next, selectedRowKey, mailListItemSelectionSource, true /* isRangeSelection */);
    }
    else if (selectedRowKeys.length == 0) {
        // Select the first item when there is no selection
        selectFirstRow(tableView, mailListItemSelectionSource);
    }
}
//# sourceMappingURL=multiselectNextRowInternal.js.map